import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ReasoningEffort } from "@/types/chat.type";

interface WorkshopModelStore {
  /** Last-picked model id (`"auto"` or a concrete provider id). */
  modelId: string | null;
  reasoningEffort: ReasoningEffort | null;
  setSelection: (modelId: string, effort: ReasoningEffort) => void;
}

const WORKSHOP_MODEL_STORAGE_KEY = "workshop-model-store";

/**
 * The workshop's own last-picked model/effort. Separate from chatModelStore on
 * purpose — the workshop must not inherit Universe/Strategy/Calendar picks.
 *
 * This is only the DEFAULT for new threads and draft chats: an existing
 * session's row (server-persisted) always wins when it carries a pick.
 */
export const useWorkshopModelStore = create<WorkshopModelStore>()(
  persist(
    (set) => ({
      modelId: null,
      reasoningEffort: null,
      setSelection: (modelId, reasoningEffort) => set({ modelId, reasoningEffort }),
    }),
    {
      name: WORKSHOP_MODEL_STORAGE_KEY,
      partialize: (state) => ({
        modelId: state.modelId,
        reasoningEffort: state.reasoningEffort,
      }),
    },
  ),
);
